import {getSupplierQueryOptions} from "@project/application/engineering/suppliers";
import {AppErrorBoundary} from "@project/layouts";
import {createFileRoute} from "@tanstack/react-router";
import {z} from "zod";

import {routeMessages} from "../../../../../messages/routes.messages";

import {SupplierPage} from "./-page/supplier.page";
import {SupplierPending} from "./-page/supplier.pending";

const supplierSearchSchema = z.object({includeDeleted: z.boolean().default(false)});

export const Route = createFileRoute("/_app/engineering/suppliers/$supplierId")({
  component: RouteComponent,
  errorComponent: AppErrorBoundary,
  validateSearch: supplierSearchSchema,
  loaderDeps: ({search}) => ({includeDeleted: search.includeDeleted}),
  loader: async ({context: {queryClient}, deps, params}) =>
    queryClient.ensureQueryData(getSupplierQueryOptions(params.supplierId, deps.includeDeleted)),
  pendingComponent: SupplierPending,
  staticData: {
    meta: {
      getLabel: (_p: Record<string, string>, data?: unknown) => getSupplierCompanyName(data),
      getLabelDescriptor: (p: Record<string, string>) => ({
        id: routeMessages.supplierById.id,
        values: {supplierId: p["supplierId"]},
      }),
    },
  },
});

function RouteComponent() {
  const {supplierId} = Route.useParams();
  const {includeDeleted} = Route.useSearch();

  return <SupplierPage supplierId={supplierId} includeDeleted={includeDeleted} />;
}

function getSupplierCompanyName(data: unknown) {
  if (
    typeof data !== "object" ||
    data === null ||
    !("company" in data) ||
    typeof data.company !== "object" ||
    data.company === null ||
    !("companyName" in data.company) ||
    typeof data.company.companyName !== "string"
  ) {
    return undefined;
  }

  return data.company.companyName;
}
